import React, { useState } from "react";
import PopUp from "../utils/PopUp";
import axios from "axios";
import { toast } from "sonner";

const AddLogistics = ({ isVisible, onClose, location_logistics_name, location_logistics_cords, last_user_id }) => {
  const [form, setForm] = useState({
    unique_code: "",
    name: "",
    category: "",
    conditions: "",
    buy_at: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(() => ({
      ...form,
      [name]: value,
    }));
  };

  const handleSubmit = async() => {
    const {
        unique_code,
        name,
        category,
        conditions,
        buy_at,
      } = form
    const data = {
        uniqueCode: unique_code,
        name,
        category,
        status: "Ready",
        id_user: last_user_id,
        location_logistics_name,
        location_logistics_cords,
        conditions: Number(conditions),
        buy_at,
    }

    try{
        const api = `${process.env.REACT_APP_SERVER}/api/logistics/add`
        const result = await axios.post(api,data)

        toast.success("Berhasil menambahkan logsitik")
        window.location.reload()
    }catch(err){
        console.error("Error Post DATA", err)
       toast.error("Maaf ada kesalahan, gagal post data")
    }
  };
  
  return (
    <PopUp isVisible={isVisible} onClose={onClose} title={"Add Logistic"}>
      <input
        type="text"
        value={form.unique_code}
        name={"unique_code"}
        onChange={handleChange}
        placeholder="Unique code"
        className="input mt-4 input-bordered w-full"
      />
      <input
        type="text"
        value={form.name}
        name={"name"}
        onChange={handleChange}
        placeholder="Name"
        className="input mt-4 input-bordered w-full"
      />
      <input
        type="text"
        value={form.category}
        name={"category"}
        onChange={handleChange}
        placeholder="Category"
        className="input mt-4 input-bordered w-full"
      />
    <div className="flex gap-2">
      <input
        type="date"
        value={form.buy_at}
        name={"buy_at"}
        onChange={handleChange}
        placeholder="Buy at"
        className="input mt-4 input-bordered w-full"
      />
      <input
        type="number"
        value={form.conditions}
        name={"conditions"}
        onChange={handleChange}
        placeholder="%"
        className="input mt-4 input-bordered w-12"
      />
    </div>
      <div className="flex justify-end px-2 w-full mt-4">
        <button
          onClick={handleSubmit}
          className="btn text-white bg-green-700  btn-success btn-xs"
        >
          Submit
        </button>
      </div>
    </PopUp>
  );
};

// id
// id_last_history
//! unique_code
//! name
//! category
//! conditions
//! buy_at
// status
//! last_user_id
//! location_logistics_name
//! location_logistics_cords
// created_at
// updated_at

export default AddLogistics;
